import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'El Problema',
    href: '#problema'
  }, {
    name: 'La Solución',
    href: '#solucion'
  }, {
    name: 'La Tienda',
    href: '#tienda'
  }, {
    name: 'Contacto',
    href: '#contacto'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-cream-50/95 backdrop-blur-sm shadow-sm py-3' : 'bg-transparent py-5'}`} data-id="element-162">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex justify-between items-center" data-id="element-163">
        <a href="#" className="flex-shrink-0 z-50" data-id="element-164">
          <div className="flex flex-col items-start leading-none" data-id="element-165">
            <span className={`text-xl font-display font-medium tracking-[0.25em] transition-colors duration-300 ${isScrolled ? 'text-charcoal' : 'text-cream-50 drop-shadow-md'}`} data-id="element-166">
              TERRACOTTA
            </span>
            <span className={`text-[0.65rem] font-body font-light tracking-[0.45em] uppercase mt-0.5 transition-colors duration-300 ${isScrolled ? 'text-olive-500' : 'text-cream-200 drop-shadow-md'}`} data-id="element-167">
              ATELIER
            </span>
          </div>
        </a>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center space-x-8" data-id="element-168">
          {navLinks.map(link => <a key={link.name} href={link.href} className={`text-sm font-medium tracking-wide transition-colors ${isScrolled ? 'text-charcoal hover:text-olive-500' : 'text-cream-50 hover:text-cream-200 drop-shadow-md'}`} data-id="element-169">
              {link.name}
            </a>)}
          <a href="https://wa.me/573160551859?text=Quiero%20construir%20mi%20imagen" target="_blank" rel="noopener noreferrer" className={`px-5 py-2.5 rounded-none text-sm font-medium transition-all ${isScrolled ? 'bg-olive-500 text-cream-50 hover:bg-olive-600' : 'bg-cream-50 text-olive-900 hover:bg-cream-200'}`} data-id="element-170">
            Agenda tu visita
          </a>
        </nav>

        {/* Mobile Menu Toggle */}
        <button className="md:hidden z-50 p-2" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-171">
          {isMobileMenuOpen ? <XIcon className="h-6 w-6 text-charcoal" data-id="element-172" /> : <MenuIcon className={`h-6 w-6 ${isScrolled ? 'text-charcoal' : 'text-cream-50 drop-shadow-md'}`} data-id="element-173" />}
        </button>

        {/* Mobile Nav */}
        <AnimatePresence data-id="element-174">
          {isMobileMenuOpen && <motion.div initial={{
          opacity: 0,
          y: -20
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: -20
        }} className="absolute top-0 left-0 right-0 h-screen bg-cream-50 flex flex-col items-center justify-center space-y-8 pt-20 px-4 md:hidden" data-id="element-175">
              {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setIsMobileMenuOpen(false)} className="text-2xl font-display text-charcoal hover:text-olive-500" data-id="element-176">
                  {link.name}
                </a>)}
              <a href="https://wa.me/573160551859?text=Quiero%20construir%20mi%20imagen" target="_blank" rel="noopener noreferrer" className="mt-8 px-8 py-4 bg-olive-500 text-cream-50 text-lg font-medium w-full text-center" data-id="element-177">
                Escríbenos al WhatsApp
              </a>
            </motion.div>}
        </AnimatePresence>
      </div>
    </header>;
}